import { Injectable } from '@angular/core';
import { map, BehaviorSubject, Observable } from 'rxjs';

import { SlidesType, FindSlideByTargetAndReferenceGQL } from '@sifca-monorepo/terminal-generator';
import {
  WalletTypeEnum,
  LandingPagesType,
  LandingPageTypeEnum,
  FindLandingPagesByTargetAndTypeAndStatusPaginatedGQL,
} from '@sifca-monorepo/widget-generator';

@Injectable({
  providedIn: 'root',
})
export class MobilePagesService {
  private slide: BehaviorSubject<SlidesType> = new BehaviorSubject(null);
  private loadingPage: BehaviorSubject<boolean> = new BehaviorSubject(null);
  private landingPage: BehaviorSubject<LandingPagesType> = new BehaviorSubject(null);
  private landingPages: BehaviorSubject<LandingPagesType[]> = new BehaviorSubject([]);

  pageIndex = 0;
  pageLimit = 12;
  walletType: WalletTypeEnum;

  get slide$(): Observable<SlidesType> {
    return this.slide.asObservable();
  }

  get loadingPage$(): Observable<boolean> {
    return this.loadingPage.asObservable();
  }

  get landingPages$(): Observable<LandingPagesType[]> {
    return this.landingPages.asObservable();
  }

  get landingPage$(): Observable<LandingPagesType> {
    return this.landingPage.asObservable();
  }
  set landingPage$(value: any) {
    this.landingPage.next(value);
  }

  constructor(
    private findLandingPagesByTargetAndTypeAndStatusPaginatedGQL: FindLandingPagesByTargetAndTypeAndStatusPaginatedGQL,
    private findSlideByTargetAndReferenceGQL: FindSlideByTargetAndReferenceGQL,
  ) {}

  findLandingPagesByTargetAndTypeAndStatusPaginated(pageType: LandingPageTypeEnum): Observable<LandingPagesType> {
    this.loadingPage.next(true);
    return this.findLandingPagesByTargetAndTypeAndStatusPaginatedGQL.fetch({ pageType, target: { pos: localStorage.getItem('posId') } }).pipe(
      map(({ data }: any) => {
        if (data) {
          this.landingPages.next(data.findLandingPagesByTargetAndTypeAndStatusPaginated.objects);
          this.landingPage.next(data.findLandingPagesByTargetAndTypeAndStatusPaginated.objects[0]);
          this.loadingPage.next(false);
          return data.findLandingPagesByTargetAndTypeAndStatusPaginated.objects[0];
        }
      }),
    );
  }

  findSlideByTargetAndReference(reference: string): Observable<SlidesType> {
    return this.findSlideByTargetAndReferenceGQL
      .fetch({
        reference,
        target: { pos: localStorage.getItem('posId') },
      })
      .pipe(
        map(({ data }: any) => {
          if (data) {
            this.slide.next(data.findSlideByTargetAndReference);
            return data.findSlideByTargetAndReference;
          }
        }),
      );
  }
}
